import { Spin } from "antd";
import { useTranslation } from "react-i18next";

export function RouteLoading() {
  const { t } = useTranslation("common");

  return (
    <main className="flex min-h-screen items-center justify-center" aria-label={t("status.loading")}>
      <Spin size="large" />
    </main>
  );
}
